<template>
  <button-primary
    :text="btnText"
    type="submit"
    flex-row-reverse
    :disabled="totalItens === 0"
    :loading="loading"
    @click="confirmTerminate()"
  />
</template>
<script>
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import RouterMixin from '@/app/arch/mixins/RouterMixin';
import ButtonPrimary from 'Arch/components/Buttons/ButtonPrimary.vue';

export default {
  name: 'TerminateAccount',
  components: { ButtonPrimary },
  mixins: [NotificationMixin, RouterMixin],
  data: () => ({
    requestClass: '',
    dialogTitle: '',
    dialogText: '',
    totalItens: 0,
    btnText: '',
    successMessage: '',
    crudListName: '',
    confirmButtonText: 'CONFIRMAR',
    cancelButtonText: 'CANCELAR',
    loading: false,
    failMessage: 'Falha ao solicitar download',
  }),
  computed: {
    proxyRequest() {
      return (params = {}) => this.requestClass.terminateCsv(params);
    },
    getParams() {
      return this.getQueryParams(
        this.$route.query,
      );
    },
  },
  created() {
    this.$root.$on(`total-itens-${this.crudListName}`, (data) => {
      this.totalItens = data;
    });
  },
  methods: {
    confirmTerminate() {
      this.confirmacao(
        this.dialogTitle,
        this.handleSetRepleceItens(this.dialogText),
        this.terminateCallback,
      );
    },
    handleSetRepleceItens(message) {
      return message.replace('{count}', `${this.totalItens}`);
    },
    confirmacao(title, text, callback) {
      this.showConfirmDialog({
        title,
        text,
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
      }).then((data) => {
        this.confirmCallBack(data, callback);
      });
    },
    confirmCallBack(data, callback) {
      if (data.value) {
        callback();
      }
    },
    terminateCallback() {
      const params = this.removePage(
        this.getParams,
      );

      this.callService(
        this.successMessage,
        this.proxyRequest({
          ...params,
        }),
      );
    },
    removePage(obj) {
      return Object.keys(obj)
        .filter((key) => !(key.toLowerCase() === 'page'))
        .map((key) => ({ [key]: obj[key] }))
        .reduce((acc, crr) => ({ ...acc, ...crr }), {});
    },
    callService(message, request) {
      this.loading = true;
      request.then((res) => {
        this.successRequestCallBack(res, message);
      }).catch((err) => {
        this.showErrorToast({
          text: this.getReportMessageErr(err),
        });
      }).finally(() => {
        this.$root.$emit(`refresh-crud-${this.crudListName}`, {});
        this.loading = false;
      });
    },
    successRequestCallBack(res, message) {
      this.makeTerminateResponse(res);
      this.showSuccessToast({
        text: message,
      });
    },
    makeTerminateResponse(response) {
      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=utf-8' });
      const fileName = this.prepareTerminateFileName(response);

      this.makeExported(blob, fileName);
    },
    prepareTerminateFileName(response) {
      const header = response.headers['content-disposition'];
      if (this.hasString(header)) {
        return header.split('filename=')[1].split(';')[0];
      }
      const url = response.request.responseURL;
      if (this.hasString(url)) {
        const lastBarIndex = String(url).lastIndexOf('/');
        return String(url).split('').slice(lastBarIndex)
          .join('');
      }
      return this.crudListName;
    },
    hasString(item) {
      return item && typeof item === 'string';
    },
    makeExported(data, name) {
      const link = document.createElement('a');
      link.download = name;
      link.href = URL.createObjectURL(data, { type: 'text/plain' });
      link.click();
      URL.revokeObjectURL(link.href);
    },
    getReportMessageErr(err) {
      if (!err) return this.failMessage;
      if ('response' in err) return err.response.data.message;
      if ('message' in err) return err.message;
      return this.failMessage;
    },
  },

};
</script>
